import Accordion, { AccordionItem } from '@ingka/accordion';
import { useTranslation } from 'react-i18next';
import { TermsTable } from './tables/TermsTable';
import { InformationTable } from './tables/InformationTable';
import { PrizeEmailTable } from './tables/PrizeEmailTable';
import { SwipeInformationTable } from './tables/SwipeInformationTable';
import type { LotteryConfigData } from './types';
import { SimpleSignupInformationTable } from './tables/SimpleSignupInformationTable';

type LotteryConfigOverviewProps = {
  values: LotteryConfigData;
  currency: string;
  storesDictionary: Record<string, string>;
  timezone: string;
};

export const LotteryConfigOverview: React.FC<LotteryConfigOverviewProps> = ({
  values,
  currency,
  storesDictionary,
  timezone,
}) => {
  const { t } = useTranslation();

  const showSwipe = Object.values(values.translation).some(({ swipe }) => swipe !== undefined);
  const showEmail = Object.values(values.translation).some(({ email }) => email !== undefined);
  const showLegalTerms = Object.values(values.translation).some(({ legal }) => legal !== undefined);
  const showSimpleSignup = !!values.lottery.simpleSignup;

  return (
    <Accordion>
      <AccordionItem
        title={`${t('form-accordion-lottery-details')}`}
        id="lottery-config-overview-information"
        open
      >
        <InformationTable
          values={values}
          currency={currency}
          storesDictionary={storesDictionary}
          timezone={timezone}
        />
      </AccordionItem>
      {showLegalTerms && (
        <AccordionItem
          title={`${t('form-accordion-legal-terms')}`}
          id="lottery-config-overview-legal-terms"
        >
          <TermsTable values={values} />
        </AccordionItem>
      )}
      {showSwipe && (
        <AccordionItem
          title={`${t('form-accordion-swipe-information')}`}
          id="lottery-config-overview-swipe-information"
        >
          <SwipeInformationTable values={values} />
        </AccordionItem>
      )}
      {showSimpleSignup && (
        <AccordionItem
          title={`${t('form-accordion-simple-signup-information')}`}
          id="lottery-config-overview-simple-signup-information"
        >
          <SimpleSignupInformationTable values={values} />
        </AccordionItem>
      )}
      {showEmail && showSwipe && (
        <AccordionItem
          title={`${t('form-accordion-winner-email')}`}
          id="lottery-config-overview-prize-email"
        >
          <PrizeEmailTable values={values} />
        </AccordionItem>
      )}
      {showEmail && !showSwipe && (
        <AccordionItem
          title={`${t('form-accordion-email-translations')}`}
          id="lottery-config-overview-prize-email"
        >
          <PrizeEmailTable values={values} />
        </AccordionItem>
      )}
    </Accordion>
  );
};
